// Field defs used by MMCollection to translate filters for Drupal `api/incidents`.
// Not a JsonApiModel and not used for HTTP.
export const incidentDrupalFilterFields = {
	created: { type: Date, default: () => new Date() },
	changed: { type: Date, default: () => new Date() },
	title: { type: String, default: '' },
	team: { referenceType: 'node--team' },
	archived: { type: Boolean, default: false },
	status: { referenceType: 'taxonomy_term--incident_status' },
	volume: { type: Number, default: 0 },
	category: { referenceType: 'taxonomy_term--incident_categories' },
	priority: { type: Boolean, default: false },
	legal_info: { type: String, default: '' },
	report_type: { referenceType: 'taxonomy_term--incident_report_type' },
	post_code: { type: String, default: '' },
};

export default function incidentDrupalFilterParent() {
	return { fields: incidentDrupalFilterFields };
}
